/* jshint esversion: 6 */
/* jshint ignore:start */
import React from "react";
import Lottie from "lottie-react";
import maintenanceJson from "../JSONFile/maintance_mode.json";
import GoMeet from "../images/logos/logo.png";

const MaintenanceMode = () => {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-white px-4 py-8 text-center select-none">
      {/* Brand Header */}
      <div className="mb-4 flex items-center justify-center">
        <img
          src={GoMeet}
          alt="GoMeet Infinite Match"
          className="h-16 sm:h-20 w-auto object-contain"
        />
      </div>

      {/* Lottie Animation */}
      <div className="w-full max-w-sm sm:max-w-md h-64 sm:h-72 flex items-center justify-center my-2">
        <Lottie
          animationData={maintenanceJson}
          loop={true}
          className="w-full h-full"
        />
      </div>

      {/* Heading with Heart Emoticons */}
      <div className="flex items-center justify-center gap-2 my-3">
        <span className="text-xl sm:text-2xl" role="img" aria-label="heart">💕</span>
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800 m-0">
          Love Under Construction
        </h2>
        <span className="text-xl sm:text-2xl" role="img" aria-label="heart">💕</span>
      </div>

      {/* Message */}
      <p className="max-w-md text-sm sm:text-base text-gray-600 font-medium leading-relaxed mt-2 mb-6 px-4">
        We're making improvements to enhance your dating experience. Back soon!
      </p>

      {/* Status Badge */}
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#f5e8ff] text-[#9610FF] text-xs sm:text-sm font-semibold shadow-sm">
        <span className="w-2.5 h-2.5 rounded-full bg-[#9610FF] animate-pulse"></span>
        System Maintenance In Progress
      </div>
    </div>
  );
};

export default MaintenanceMode;
/* jshint ignore:end */
